import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { LeaveConfirmationDialogComponent } from "./leave-confirmation-dialog.component";

@NgModule({
  declarations: [LeaveConfirmationDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  exports: [LeaveConfirmationDialogComponent],
})
export class LeaveConfirmationDialogModule {}
